import { EnvironmentProviders, Provider } from '@angular/core';

import { iconFileNamePathsObject, provideSvgIcon } from '@guardfinder/shared';

/**
 * Provides the SvgIconService with configuration for the Pro app.
 *
 * This function uses the shared provideSvgIcon function to configure the SvgIconService
 * with the Pro app's specific settings.
 *
 * @returns An array of providers that includes the SvgIconService configuration
 */
export function provideSvgIconService(): Provider | EnvironmentProviders[] {
    return provideSvgIcon({
        iconAssetPath: '/assets/svg-icons/',
        iconFileNamesObject: iconFileNamePathsObject,
        useIonIconComponent: true
    });
}
